import selectors from '../../rootSelectors';
import { goTo, goToStartPage, goToDonePage } from '../navigation/navigationActions';
import { STATUS } from '../../constants/result';
import { resumeAssessment } from '../resume/resumeActions';
import { trackStartAssessment, trackResumeAssessment } from '../lrs/lrsActions';
import * as mazeActions from '../api/mazeActions';
import { MAZE } from '../../constants/measure';
import { cacheMazeInstructions } from '../../maze/mazeActions';

export const beginAssessment = () => (dispatch, getStore) => {
    const state = getStore();
    const nextPlaylistItem = selectors.getNextIncompleteMeasure(state);
    const isInstructionEnabled = selectors.getIsAssessmentInstructionEnabled(state);

    if (nextPlaylistItem !== undefined && !nextPlaylistItem.ignore) {
        // TODO: make STATUS consts numbers, so that they can be compared
        if (nextPlaylistItem.status === STATUS.IN_PROGRESS) {
            dispatch(resumeAssessment(nextPlaylistItem));
            dispatch(trackResumeAssessment(nextPlaylistItem.name, nextPlaylistItem.measure));
        } else {
            const targetURL = (nextPlaylistItem.assessmentURL && !isInstructionEnabled)
                ? nextPlaylistItem.assessmentURL : nextPlaylistItem.startingURL;
            dispatch(goTo(targetURL));
            dispatch(trackStartAssessment(nextPlaylistItem.name, nextPlaylistItem.measure));
        }
    }
};

export const completeAssessment = () => (dispatch, getStore) => {
    const nextPlaylistItem = selectors.getNextIncompleteMeasure(getStore());
    if (nextPlaylistItem === undefined) {
        dispatch(goToDonePage());
    } else {
        dispatch(goToStartPage());
    }
};

export const syncOfflineResults = () => async (dispatch, getStore) => {
    const state = getStore();
    const studentUid = selectors.getUserId(state);
    // Here can be placed actions to sync other offline results
    return dispatch(mazeActions.saveOfflineResponse(studentUid));
};

export const cacheInstructions = (nextMeasure) => async (dispatch) => {
    const { name } = nextMeasure || {};
    if (name === MAZE.NAME) {
        await dispatch(cacheMazeInstructions());
    }
};
